import { Box } from 'grommet';
import styled from 'styled-components';

export const ModalTitleWrapper = styled(Box)`
	position: relative;
	min-height: 60px;
`;
